<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper w-100">
          <h5>{{ $t("PLACEHOLDERS.walletTransactions") }}</h5>
          <div class="col-12 text-end">
            <v-btn @click="$router.go(-1)" style="color: #e1423d">
              <i class="fas fa-backward"></i>
            </v-btn>
          </div>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Wallet Balance Card =========== -->
      <div class="wallet_balance_card mb-4" v-if="walletBalance !== null">
        <div class="balance_content">
          <h6>{{ $t("PLACEHOLDERS.currentBalance") }}</h6>
          <h3>{{ walletBalance }} {{ $t("PLACEHOLDERS.riyal") }}</h3>
        </div>
      </div>
      <!--  =========== End:: Wallet Balance Card =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- End:: No Data State -->

        <!-- Start:: Serial Number -->
        <template v-slot:[`item.id`]="{ item, index }">
          <p>
            {{
              (paginations.current_page - 1) * paginations.items_per_page +
              index +
              1
            }}
          </p>
        </template>
        <!-- End:: Serial Number -->

        <!-- Start:: Transaction Type -->
        <template v-slot:[`item.type`]="{ item }">
          <v-chip
            :color="item.type === 'credit' ? 'success' : 'error'"
            outlined
            small
          >
            <i
              :class="item.type === 'credit' ? 'fas fa-plus' : 'fas fa-minus'"
              class="mr-1"
            ></i>
            {{
              item.type === "credit"
                ? $t("PLACEHOLDERS.credit")
                : $t("PLACEHOLDERS.debit")
            }}
          </v-chip>
        </template>
        <!-- End:: Transaction Type -->

        <!-- Start:: Amount -->
        <template v-slot:[`item.amount`]="{ item }">
          <span
            :style="{
              color: item.type === 'credit' ? '#4caf50' : '#f44336',
              fontWeight: '600',
            }"
          >
            {{ item.type === "credit" ? "+" : "-" }}{{ Math.abs(item.amount) }}
            {{ $t("PLACEHOLDERS.riyal") }}
          </span>
        </template>
        <!-- End:: Amount -->

        <!-- Start:: Balance Before -->
        <template v-slot:[`item.balance_before`]="{ item }">
          <p
            v-if="
              item.balance_before !== null && item.balance_before !== undefined
            "
          >
            {{ item.balance_before }} {{ $t("PLACEHOLDERS.riyal") }}
          </p>
          <p class="blue-grey--text text--darken-1" v-else>-</p>
        </template>
        <!-- End:: Balance Before -->

        <!-- Start:: Balance After -->
        <template v-slot:[`item.balance_after`]="{ item }">
          <p
            v-if="
              item.balance_after !== null && item.balance_after !== undefined
            "
          >
            {{ item.balance_after }} {{ $t("PLACEHOLDERS.riyal") }}
          </p>
          <p class="blue-grey--text text--darken-1" v-else>-</p>
        </template>
        <!-- End:: Balance After -->

        <!-- Start:: Notes -->
        <template v-slot:[`item.notes`]="{ item }">
          <p v-if="item.notes">{{ item.notes }}</p>
          <p class="blue-grey--text text--darken-1" v-else>-</p>
        </template>
        <!-- End:: Notes -->

        <!-- Start:: Created At -->
        <template v-slot:[`item.created_at`]="{ item }">
          <p v-if="item.created_at">{{ formatDate(item.created_at) }}</p>
          <p class="blue-grey--text text--darken-1" v-else>-</p>
        </template>
        <!-- End:: Created At -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "WalletTransactions",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      // Start:: Loading Data
      loading: false,
      // End:: Loading Data

      // Start:: User ID
      userId: null,
      // End:: User ID

      // Start:: Wallet Balance
      walletBalance: null,
      // End:: Wallet Balance

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "id",
          align: "center",
          width: "80",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.transactionType"),
          value: "type",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.amount"),
          value: "amount",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.balanceBefore"),
          value: "balance_before",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.balanceAfter"),
          value: "balance_after",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.notes"),
          value: "notes",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.created_at"),
          value: "created_at",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 10,
      },
      // End:: Pagination Data
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    // Start:: Format Date
    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      const pad = (n) => (n < 10 ? `0${n}` : n);
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      return `${year}-${month}-${day}, ${hours}:${minutes}:${seconds}`;
    },
    // End:: Format Date

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },

    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `service-requesters/${this.userId}/wallet/transactions`,
          params: {
            page: this.paginations.current_page,
            per_page: 10,
          },
        });
        this.loading = false;

        // Extract transactions and wallet balance from response
        // API returns transactions array directly in data
        if (Array.isArray(res.data.data)) {
          this.tableRows = res.data.data;
          // Get wallet balance from the last transaction's balance_after or first item
          if (res.data.data.length > 0) {
            this.walletBalance =
              res.data.data[0].balance_after ?? res.data.wallet_balance ?? null;
          }
        } else {
          this.tableRows = res.data.data?.transactions || [];
          this.walletBalance =
            res.data.data?.wallet_balance ?? res.data.wallet_balance ?? null;
        }

        this.paginations.last_page = res.data.pagination?.last_page || 1;
        this.paginations.items_per_page = res.data.pagination?.per_page || 10;
      } catch (error) {
        this.loading = false;
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      }
    },
    // End:: Set Table Rows
  },

  created() {
    // Start:: Fire Methods
    this.userId = this.$route.params.id;
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.wallet_balance_card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.balance_content h6 {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.balance_content h3 {
  color: #ffffff;
  font-size: 36px;
  font-weight: 700;
  margin: 0;
}
</style>
